<div class="jumbotron container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-8">
            <div class="etiquetaFACeB2B display-4 welcome_element_to_target" [innerHTML]="'pub.search.welcome' | translate"></div>
            <h1 translate id="dispara">pub.search.title</h1>
            <form class="form-inline">
                <div class="form-group">
                    <label for="company" *ngIf="receiverCriteria.filter=='company'" translate>pub.search.labelSearch</label>
                    <label for="identifier" *ngIf="receiverCriteria.filter=='identifier'" translate>pub.search.labelSearch</label>
                    <label for="code" *ngIf="receiverCriteria.filter=='code'" translate>pub.search.labelSearch</label>
                    <div class=" buscador buscador_element_to_target">
                        <input (keyup.enter)="search()" [(ngModel)]="receiverCriteria.value" class="form-control col" *ngIf="receiverCriteria.filter=='company'" name="company" id="company" type="search" placeholder="{{'pub.search.inputClientName' | translate}}">
                        <input (keyup.enter)="search()" [(ngModel)]="receiverCriteria.value" class="form-control col" *ngIf="receiverCriteria.filter=='identifier'" name="identifier" id="identifier" type="search" placeholder="{{'pub.search.inputClientNIF' | translate}}">
                        <input (keyup.enter)="search()" [(ngModel)]="receiverCriteria.value" class="form-control col" *ngIf="receiverCriteria.filter=='code'" name="code" id="code" type="search" placeholder="{{'pub.search.inputClientDIRe' | translate}}"  >
                        <button (click)="search()" type="button" class="btn btn-success"><i class="fa fa-search"></i></button>
                    </div>
                </div>
                <div class="busquedaRadios">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input [(ngModel)]="receiverCriteria.filter" type="radio" class="form-check-input" name="busquedaFace" value="company">
                            <span class="pseudoRadio"></span>
                            <span translate> pub.search.radiosearch1</span>
                        </label>
                    </div>
                    <div class="form-check">
                        <label class="form-check-label">
                            <input [(ngModel)]="receiverCriteria.filter" type="radio" class="form-check-input" name="busquedaFace" value="identifier">
                            <span class="pseudoRadio"></span>
                            <span translate> pub.search.radiosearch2</span>
                        </label>
                    </div>
                    <div class="form-check">
                        <label class="form-check-label">
                            <input [(ngModel)]="receiverCriteria.filter" type="radio" class="form-check-input" name="busquedaFace" value="code">
                            <span class="pseudoRadio"></span>
                            <span translate> pub.search.radiosearch3</span>
                        </label>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-6 col-md-4 portada d-none d-md-block"><img src="assets/images/imagenJumbotron.png" alt="Jumbotron"></div>
        <div class="auxiliar col-12 ">
            <div class="col"></div>
            <div class="flecha"></div>
            <div class="col"></div>
        </div>
    </div>
</div>

<app-pub-menu (onHomeEvent)="removeElements()"></app-pub-menu>

<!-- Resultados de la Busqueda -->
<div class="searchResult" *ngIf="searchDireClick">
    <div class="card infoEmpresa">
        <div class="card-header">
            <span >
                <em *ngIf="searchText.length > 0" [innerHTML]="'pub.list.resultFilter' | translate:{ numResults: receiverList.items.length, filter: searchText}"></em>
                <em *ngIf="searchText.length === 0" [innerHTML]="'pub.list.result' | translate:{ numResults: receiverList.items.length}"></em>
            </span>
            <button (click)="removeElements()" aria-label="Close" class="close" type="button">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="card-body">
            <div class="datosEmpresa" *ngFor="let entity of receiverList.items | paginate: { itemsPerPage: 10, currentPage: p }">
                <span class="nombre">{{ entity.dire.name }}</span>
                <span class="codigo">{{ entity.dire.code }}</span>
                <span class="direccion" *ngIf="entity.dire.address != null">{{ entity.dire.address.fullAddress }}</span>
                <span class="telefonos">{{ entity.dire.phone }}</span>
            </div>
        </div>
    </div>

    <pagination-controls autoHide= "true" *ngIf="receiverList.items.length > 0" (pageChange)="p = $event"
                         previousLabel="{{'pub.list.previous' | translate}}"
                         nextLabel="{{'pub.list.next' | translate}}">
    </pagination-controls>

    <div class="separador"><span></span></div>
    <div *ngIf="renderShowMoreResults"><a (click)="showMoreResults()" translate>pub.list.showMoreResults</a></div>
</div>




// WEBPACK FOOTER //
// ./src/app/app-public/pub-searcher/pub-searcher.component.html